function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import React from 'react';
import { Radio } from "../../index";
import { getPrefixCls } from "../../../utils/common";
import "../style.less";
import payAli from "../../../assets/image/payali.png";
import paywx from "../../../assets/image/paywx.png";
import payfq from "../../../assets/image/payfq.png";
var prefixCls = getPrefixCls('SmButton');
var OrderPayType = /*#__PURE__*/function (_React$Component) {
  _inherits(OrderPayType, _React$Component);
  var _super = _createSuper(OrderPayType);
  function OrderPayType(props) {
    var _this;
    _classCallCheck(this, OrderPayType);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handlePayTypeChange", function (paytype) {
      _this.props.onChange && _this.props.onChange(paytype);
    });
    _this.state = {};
    return _this;
  }
  _createClass(OrderPayType, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _window,
        _window2,
        _window3;
      var _this$props = this.props,
        paytype = _this$props.paytype,
        showFQ = _this$props.showFQ;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Radio.Group, {
        value: paytype,
        onChange: function onChange(val) {
          return _this2.handlePayTypeChange(val);
        }
      }, /*#__PURE__*/React.createElement("label", {
        className: "".concat(prefixCls, "-pay-way")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-pay-way-title")
      }, /*#__PURE__*/React.createElement("img", {
        src: paywx,
        alt: "",
        className: "".concat(prefixCls, "-pay-way-img")
      }), "\u5FAE\u4FE1\u652F\u4ED8"), /*#__PURE__*/React.createElement(Radio, {
        value: 2
      })), (((_window = window) === null || _window === void 0 ? void 0 : (_window2 = _window['browser']) === null || _window2 === void 0 ? void 0 : _window2.desktop) || !((_window3 = window['browser']) !== null && _window3 !== void 0 && _window3.iswx)) && !this.props.hiddenAlipay && /*#__PURE__*/React.createElement("label", {
        className: "".concat(prefixCls, "-pay-way")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-pay-way-title")
      }, /*#__PURE__*/React.createElement("img", {
        src: payAli,
        alt: "",
        className: "".concat(prefixCls, "-pay-way-img")
      }), "\u652F\u4ED8\u5B9D"), /*#__PURE__*/React.createElement(Radio, {
        value: 1
      })), !!showFQ && /*#__PURE__*/React.createElement("label", {
        className: "".concat(prefixCls, "-pay-way")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-pay-way-title")
      }, /*#__PURE__*/React.createElement("img", {
        src: payfq,
        alt: "",
        className: "".concat(prefixCls, "-pay-way-img")
      }), "\u5206\u671F"), /*#__PURE__*/React.createElement(Radio, {
        value: 4
      }))));
    }
  }]);
  return OrderPayType;
}(React.Component);
export default OrderPayType;